<template>
	<nk-page commercialAccess="System" class="bank-selector" :policyClaims="['General_Bank_Selector']">
		<template #badges>
			<nk-badge system="treasury"></nk-badge>
		</template>
		<div class="nk-card h-100">
			<nk-table v-model="selectedRow" @data-changed="dataChanged" :data="banks" :options="tableOptions" ref="bankList" tabindex="101" startup @row_dbClicked="rowDbClicked">
			</nk-table>
		</div>
	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import Input from '~/components/general/nikan-input.vue'
	import $sc from '~/plugins/shortcut.collection'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import { mapGetters, mapActions, mapState } from 'vuex'
	import Switch from '~/components/general/nikan-switch.vue'
	import validators, { VRequired } from '~/statics/validators'

	export default {
		modal: {
			size: 'lg',
			stateUID: 'bank-selector',
			helpTag: 'BankList'
		},
		props: {
			data: { type: [Array, Object] },
			options: { type: Object },
		},
		data() {
			return {
				settings: {
					selectable: false,
					editable: true,
				},
				pageButtons: {
					saveButton: {
						title: this.$t('save'),
						shortcut: $sc.find('save'),
						icon: 'save',
						handle: (button, page, e) => {
							this.save().then((res) => {
								this.$nikan.formUtility.switchMode(this.pageButtons, 'select')
								this.defer(() => this.$refs.bankList.$el.focus(), 10)
							})
						},
						isPrimary: true,
						policyClaims: 'General_Bank_Edit',
						visible: true,
						disabled: true,
					},
					selectButton: {
						title: this.$t('select'),
						shortcut: $sc.find('enter-only'),
						element: () => this.$refs.bankList.$el,
						icon: 'check',
						isPrimary: true,
						visible: true,
						disabled: false,
						handle: (button, page, e) => {
							if (_.isEmpty(this.selectedRow))
								return this.$toast(this.$t('document.m.select-row'))

							this.resolve(this.selectedRow)
						},
						policyClaims: 'General_Bank_Selector',
						visible: true,
					},
				},
				localSelectedItem: null,
				selectedRow: null,
				buttons: null,
				editableButtons: null,
				tableOptions: {
					editable: false,
					searchable: false,
					allowNewRow: true,
					alwaysEmit: true,
					displayOrderEnabled: false,
					buttons: {
						addBtn: {
							options: {
								visible: true,
								policyClaims: 'General_Bank_Selector',
							}
						},
						deleteBtn: {
							options: {
								visible: true,
								policyClaims: 'General_Bank_Selector',
							}
						}
					},
					prepareNewRow: () => {
						return {
							isEnabled: true,
							companyId: this.status.company.id,
						}
					},
					columns: [
						{
							name: 'rowNumber',
							title: this.$t('row-number'),
							searchable: true,
							sortable: true,
							editable: false,
							entering: false,
							pinned: true,
							pinnable: false,
							resizable: false,
							width: 80,
						},
						{
							name: 'code',
							title: this.$t('bank.f.code'),
							searchable: true,
							sortable: true,
							editable: false,
							width: 80,
							entering: false,
							leaving: true,
							edit: false
						},
						{
							name: 'name',
							title: this.$t('bank.f.name'),
							edit: {
								component: Input,
								options: {
									format: (item) => this.$t('bank.' + item.toLowerCase()),
								},
							},
							view: {
								options: {
									_format: (item) => this.$t('bank.' + item.toLowerCase()),
									format: (name) => {
										name = name || ''
										let regx = /^[a-zA-Z].+/g
										if (name.search(regx) > -1) {
											let resourceName = 'bank.' + name
											let tname = this.$t(resourceName)
											if (tname === resourceName) {
												return name
											} else {
												return tname
											}
										} else {
											return name
										}
									},
								},
							},
							searchable: true,
							sortable: false,
							editable: true,
							width: 180,
							validators: validators(new VRequired()),
						},
						{
							name: 'countryName',
							title: this.$t('bank.f.country-name'),
							edit: {
								component: Input,
								options: {
									mode: 'string',
								},
							},
							searchable: true,
							sortable: false,
							editable: true,
							width: 150,
							validators: validators(new VRequired()),
						},
						{
							name: 'isEnabled',
							title: this.$t('bank.f.enabled'),
							type: 'dropdown',
							search: {
								prefix: 'boolean-active-deacive',
								useTranslate: true,
							},
							view: {
								component: Switch,
							},
							edit: {
								component: Switch,
							},
							editable: true,
							entering: true,
							width: 130,
							validators: validators(new VRequired()),
						},
					],
				},
			}
		},

		computed: {
			...mapGetters({
				bank_all: 'banks/all',
			}),
			banks() {
				let cloned = _.cloneDeep(this.bank_all)
				this.selectedRow = cloned[0]
				return cloned
			},
			...mapState('appContext', {
				status: (state) => state,
			}),
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge(this.settings, val)
				},
			},
		},

		created() {
			this.localSelectedItem = this.data
			this.tableOptions.editable = this.settings.editable === false ? false : this.$nikan.checkPermission('General_Bank_Selector')
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)

			let buttons = [
				this.pageButtons.selectButton,
				this.pageButtons.saveButton,
			]
			this.prepareWindow(this.$t('bank.title-list'), buttons)
		},
		methods: {
			...mapActions({
				bank_modify: 'banks/modify',
			}),
			dataChanged() {
				this.$nikan.formUtility.switchMode(this.pageButtons, 'edit')
			},
			save() {
				var that = this

				return new Promise((resolve, reject) => {
					this.$refs.bankList
						.commitChanges()
						.then((banks) => {
							this.bank_modify(banks)
								.then((result) => {
									this.$toast(this.$t('bank.m.save.success'), { type: 'success' })
									resolve(that.banks)
								})
								.catch(() => {
									that.defer(() => that.$refs.bankList.$el.focus(), 1)
								})
						})
						.catch((errorRows) => {
							if (Array.isArray(errorRows)) {
								var rowNumbers = errorRows.map((x, i) => x.rowNumber).join(',')
								dialog({
									title: this.$t('bank.m.save-bank-title'),
									body: this.$t('bank.m.save.error.rows', { rowNumbers }),
									type: 'error',
									isPrimary: true,
								})
							} else {
								dialog({
									title: this.$t('bank.m.save-bank-title'),
									body: errorRows.message,
									type: 'error',
									isPrimary: true,
								})
							}

							reject(new Error('invalid-rows'))
							that.defer(() => that.$refs.bankList.$el.focus(), 100)
						})
				})
			},
			rowDbClicked(val) {
				if (this.grandParentType() === 'modal')
					this.resolve(val)
			}
		},
	}
</script>
<style></style>
